export const objectHasValues = (obj: object): boolean => Object.values(obj).every(v => v);
